import Vue from 'vue';
import checklistGroupService from "./index";

// When the request succeeds
const success = (response, context, rental_id) => {
  context.smallLoading = false;
  context.closeModal('#duplicate-checklist-modal');
  context.newChecklistGroup = {
    title: "",
    description: "",
    checklist_group_type_id: 4,
    checklists: [],
    images: []
  };
  context.checklists = [];
  context.checklistGroupImages = [];
  context.getChecklistGroup(rental_id);
  toastr.success(context.$t('rentals.detail.checklists.duplicate_success'));
};

// When the request fails
const failed = (error, context) => {
  context.smallLoading = false;
  if (error.response && error.response.data && error.response.data.msg) {
    const errorMessages = error.response.data.msg;
    if (typeof errorMessages == 'string') {
      toastr.error(errorMessages);
    } else {
      Object.values(errorMessages).forEach(errorMessage => {
        toastr.error(errorMessage[0]);
      });
    }
  } else {
    toastr.error(error);
  }
};

export default (context, checklistGroup) => {
    return Vue.$http.post('/checklists/duplicate-check-list-groups', {checklistGroup})
        .then((response) => {
            if (response.status === 200) {
                success(response.data, context, checklistGroup.rental_id);
            }
        })
        .catch((error) => {
            failed(error, context);
        });
};



// WEBPACK FOOTER //
// ./src/app/services/checklist_group/duplicate.js